import React from 'react';
import { withReferer } from 'plugins/contextual-back';
import { columnWidth, renderList } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { renderCaseCustomer } from './common';

function booleanRenderer({ cellData }) {
  if (cellData === true) {
    return (
      <div>
        {' '}
        <i className="check icon"> </i>{' '}
      </div>
    );
  } else {
    return <div> </div>;
  }
}

function renderStatus({ cellData }) {
  let label, title;

  switch (cellData) {
    case 'DEMAND_ONGOING':
      label = 'ui blue label';
      title = 'Demande en cours';
      break;
    case 'TO_ORGANIZE':
      label = 'ui blue label';
      title = 'Contrat à organiser';
      break;
    case 'ACCEPTANCE_WAITING':
      label = 'ui blue label';
      title = "En attente d'acceptation";
      break;
    case 'TO_INSTALL':
      label = 'ui blue label';
      title = 'A installer';
      break;
    case 'PREVENTION':
      label = 'ui orange label';
      title = 'Prévention';
      break;
    case 'ELIMINATION':
      label = 'ui red label';
      title = 'Elimination';
      break;
    case 'OBSERVATION':
      label = 'ui green label';
      title = 'Surveillance';
      break;
    case 'UNINSTALLATION_WAITING':
      label = 'ui blue label';
      title = 'En attente de désinstallation';
      break;
    case 'UNINSTALLED':
      label = 'ui blue label';
      title = 'Désinstallé';
      break;
    case 'TRANSFERED':
      label = 'ui grey label';
      title = 'Transféré';
      break;
    default:
      break;
  }

  if (label && title) {
    return (
      <div className={label}>
        <span>{title}</span>
      </div>
    );
  }

  return null;
}

function renderColumns(width) {
  return [
    <Column
      key="name"
      dataKey="name"
      cellRenderer={renderCaseCustomer}
      width={columnWidth(width, 4)}
      label="Nom du chantier"
    />,
    <Column
      key="planRepair"
      dataKey="planRepair"
      cellRenderer={booleanRenderer}
      width={columnWidth(width, 3)}
      label="Travaux à prévoir"
    />,
    <Column
      key="creationDate"
      dataKey="creationDate"
      width={columnWidth(width, 3)}
      label="Date de création"
    />,
    <Column
      key="lastInterventionDate"
      dataKey="lastInterventionDate"
      width={columnWidth(width, 3)}
      label="Date de dernière intervention"
    />,
    <Column
      key="status"
      dataKey="status"
      cellRenderer={renderStatus}
      width={columnWidth(width, 3)}
      label="Statut"
    />,
  ];
}

function render(url, from) {
  const caseUrl = id => withReferer(`/pco-manager/aast/cases/${id}`, from);

  const rowClickedUrl = id => caseUrl(id);
  const loadNextUrl = url;

  renderList(rowClickedUrl, loadNextUrl, renderColumns);
}

export default function list(ctx) {
  const customerId = ctx.params.id;
  render(
    `/pco-manager/aast/customers/${customerId}/cases.json`,
    `/pco-manager/aast/customers/${customerId}/cases`
  );
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases/customer-list.js